import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnConfiguration } from 'src/common/components/ConfigurableTable/models/configurableTable';
import { getHuminizeDurationInSecFunction } from 'src/i18n/dateLocale';

const humanize = getHuminizeDurationInSecFunction(['m', 's']);

export const useProductSummaryColumns = () => {
  const { t } = useTranslation();

  const configuration: ColumnConfiguration[] = useMemo(
    () => [
      {
        field: 'bundleProductCode',
        headerName: t('productSummary.tableHeaders.productCode'),
        resizable: false,
        sortable: true,
        pinnable: false,
        width: 140,
        minWidth: 70,
        maxWidth: 300,
      },
      {
        field: 'activeCount',
        headerName: t('productSummary.tableHeaders.active'),
        resizable: false,
        sortable: true,
        pinnable: false,
        align: 'left',
        headerAlign: 'left',
        width: 100,
        minWidth: 70,
        maxWidth: 300,
      },
      {
        field: 'usedData',
        headerName: t('productSummary.tableHeaders.data'),
        resizable: false,
        sortable: true,
        pinnable: false,
        width: 168,
        minWidth: 70,
        maxWidth: 300,
        headerAlign: 'left',
        align: 'left',
      },
      {
        field: 'usedSeconds',
        headerName: t('productSummary.tableHeaders.voice'),
        resizable: false,
        sortable: true,
        pinnable: false,
        width: 248,
        minWidth: 248,
        maxWidth: 300,
        headerAlign: 'left',
        align: 'left',
        valueGetter: (value) => humanize(value),
      },
      {
        field: 'sent',
        headerName: t('productSummary.tableHeaders.sms'),
        resizable: false,
        sortable: true,
        pinnable: false,
        width: 160,
        minWidth: 70,
        maxWidth: 250,
        align: 'left',
        headerAlign: 'left',
      },
    ],
    [],
  );

  return configuration;
};
